export default function FAQSection() {
  const faqs = [
    {
      q: 'O CSSBuy é seguro?',
      a: 'Sim, o CSSBuy é uma plataforma segura utilizada por milhares de compradores em todo o mundo. Com a nossa planilha CSSBuy Spreadsheet, você tem acesso apenas a links verificados e vendedores com boa reputação, reduzindo significativamente o risco de fraudes.',
    },
    {
      q: 'Como usar o CSSBuy Spreadsheet?',
      a: 'Basta acessar a nossa planilha, escolher a categoria desejada, clicar no link do produto que lhe interessa e será redirecionado para a página do vendedor. Todos os links são organizados por categorias para facilitar a navegação.',
    },
    {
      q: 'Posso comprar em Portugal e no Brasil?',
      a: 'Sim! O CSSBuy oferece envio internacional para Portugal, Brasil e diversos outros países. A nossa planilha é especialmente focada nos mercados português e brasileiro, com informações atualizadas sobre envios e taxas.',
    },
    {
      q: 'Qual é o melhor CSSBuy Spreadsheet?',
      a: 'O cssbuyspreadsheet.cloud é reconhecido como o melhor CSSBuy Spreadsheet em português. Atualizamos diariamente, verificamos todos os links manualmente e organizamos os produtos em 14 categorias para facilitar a sua experiência de compra.',
    },
    {
      q: 'Quanto custa o envio internacional?',
      a: 'Os custos de envio variam conforme o peso, dimensões do produto e país de destino. O CSSBuy oferece várias opções de transporte com diferentes prazos e preços. Na nossa planilha, incluímos estimativas de custo para ajudar no seu planeamento.',
    },
    {
      q: 'Como evitar golpes ao comprar?',
      a: 'Utilize sempre a nossa planilha CSSBuy Spreadsheet com links verificados. Verifique a reputação do vendedor, leia comentários de outros compradores, e nunca faça pagamentos fora da plataforma. A nossa equipa remove diariamente links de vendedores não confiáveis.',
    },
  ];

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqs.map((faq) => ({
      '@type': 'Question',
      'name': faq.q,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.a,
      },
    })),
  };

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="w-full px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-14">
            <span className="inline-flex items-center gap-2 text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
              <i className="ri-question-answer-line text-sm"></i>
              FAQ
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              Perguntas Frequentes
            </h2>
            <p className="text-foreground-500 text-sm max-w-lg mx-auto">
              Tire as suas dúvidas sobre o CSSBuy Spreadsheet e comece a comprar com mais segurança hoje mesmo.
            </p>
          </div>

          {/* FAQ Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {faqs.slice(0, 3).map((faq, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-2xl p-6 border border-background-200/70 transition-all duration-300 hover:border-accent-300"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-question-line text-accent-600 text-sm"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 leading-snug">{faq.q}</h3>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed pl-11">{faq.a}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
            {faqs.slice(3, 5).map((faq, i) => (
              <div
                key={i + 3}
                className="bg-background-100 rounded-2xl p-6 border border-background-200/70 transition-all duration-300 hover:border-accent-300"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-question-line text-accent-600 text-sm"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 leading-snug">{faq.q}</h3>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed pl-11">{faq.a}</p>
              </div>
            ))}
            {/* Safety card with image */}
            <div className="bg-foreground-950 rounded-2xl p-6 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Friendly%20diverse%20customer%20support%20team%20of%20three%20young%20professionals%20collaborating%20around%20a%20modern%20white%20desk%20in%20bright%20airy%20office%20with%20large%20windows%20and%20indoor%20plants%20natural%20daylight%20creating%20warm%20welcoming%20atmosphere%20genuine%20helpful%20expressions%20casual%20smart%20attire%20in%20neutral%20tones%20laptop%20and%20documents%20on%20desk%20Scandinavian%20office%20interior%20design%20authentic%20teamwork%20moment%20professional%20yet%20approachable%20vibe%20high%20detail%20genuine%20connection%20between%20team%20members&width=800&height=600&seq=faq-support-v2&orientation=landscape"
                alt="Equipa de suporte CSSBuy Spreadsheet"
                className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
                loading="lazy"
              />
              <div className="relative z-10">
                <p className="text-white text-sm font-semibold mb-2">Equipa Editorial</p>
                <p className="text-white/60 text-xs leading-relaxed mb-4">
                  Especialistas em compras internacionais com mais de 5 anos de experiência. Atualizamos a planilha semanalmente com fontes verificadas.
                </p>
                <span className="inline-block px-3 py-1 bg-accent-500 text-foreground-950 text-xs font-semibold rounded-full">
                  Suporte Premium
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}